import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=a712b532&scoped=true&"
import script from "./archive.vue?vue&type=script&lang=ts&"
export * from "./archive.vue?vue&type=script&lang=ts&"
import style0 from "./archive.vue?vue&type=style&index=0&id=a712b532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a712b532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a712b532')) {
      api.createRecord('a712b532', component.options)
    } else {
      api.reload('a712b532', component.options)
    }
    module.hot.accept("./archive.vue?vue&type=template&id=a712b532&scoped=true&", function () {
      api.rerender('a712b532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_recipient/archive.vue"
export default component.exports